<template>
	<div>
		<nav-header :navText="headerText" class="mb-3" />
		<b-container class="px-4">
			<b-row>
				<b-col>
					<b-tabs class="mt-4">
<!--						<b-tab title="General Settings">
						
						</b-tab>-->
						<b-tab title="Fulfilment (Slot Type) Options" active>
							<b-row class="">
								<b-col class="pt-4">
									<b-row class="mt-2"> 
										<b-col class="pl-4 pb-1">
										<h6 class="ml-3 d-block"><strong>Set the fulfillment types you wish to offer:</strong></h6>
										</b-col>
									</b-row>									
									<b-row class="pl-4 mt-1">
										<b-col>
											<b-form-group class="">
												<b-form-checkbox-group
													id="orderTypesEnabled"
													v-model="orderTypesEnabledSelected"
													:options="orderTypesEnabledOptions"
													name="orderTypesEnabled"
													class="ml-4"
												></b-form-checkbox-group>
											</b-form-group>										
										</b-col>
										<b-col>
										</b-col>
									</b-row>
									<b-row class="mt-4">
										<b-col class="pl-4">
										<h6 class="ml-3 d-block"><strong>Set the number of available slots per hour:</strong></h6>
										</b-col>
									</b-row>
									<b-row class="">
										<b-col cols="3" class="pl-4 pt-2">
											<h6 class="ml-3 d-block">Order&Collect Desk</h6>
											<b-form-input v-model='numberCCSlots'  type="number" class='ml-3 mb-1 d-block w-25' min="1" size='sm' :disabled="numberCCSlotsDisabled"></b-form-input>
										</b-col>
										<b-col cols="3" class="pl-4 pt-2">
											<h6 class="ml-3 d-block">Order&Collect Locker</h6>
											<b-form-input v-model='numberLSlots'  type="number" class='ml-3 mb-1 d-block w-25' min="1" size='sm' :disabled="numberLSlotsDisabled"></b-form-input>
										</b-col>
										<b-col cols="3" class="pl-4 pt-2">
											<h6 class="ml-3 d-block">Delivery</h6>
											<b-form-input v-model='numberDSlots'  type="number" class='ml-3 mb-1 d-block w-25' min="1" size='sm' :disabled="numberDSlotsDisabled"></b-form-input>
										</b-col>										
									</b-row>
									<b-row class="mt-4">
										<b-col class="pl-4">
										<h6 class="ml-3 d-block"><strong>Set the minimum number of hours ahead a slot can be booked:</strong></h6>
										</b-col>
									</b-row>
									<b-row class="">
										<b-col cols="4" class="pl-4 pt-2">
											<b-form-input v-model='offsetCCSlots'  type="number" class='ml-3 mb-1 d-block w-25' min="0" size='sm' :disabled="offsetCCSlotsDisabled"></b-form-input>
										</b-col>
										<b-col cols="2" class="pl-4 pt-2 d-none">
											<h6 class="ml-3 d-block">Locker Slots</h6>
											<b-form-input v-model='offsetLSlots'  type="number" class='ml-3 mb-1 d-block' min="0" size='sm' :disabled="offsetLSlotsDisabled"></b-form-input>
										</b-col>
										<b-col cols="2" class="pl-4 pt-2 d-none">
											<h6 class="ml-3 d-block">Delivery Slots</h6>
											<b-form-input v-model='offsetDSlots'  type="number" class='ml-3 mb-1 d-block' min="0" size='sm' :disabled="offsetDSlotsDisabled"></b-form-input>
										</b-col>
										<b-col cols="8" class="mt-2 pt-4">
											<b-button :variant="confirmSlotTypeVariant" class="float-left" size='sm' @click="confirmSettingChanges('orderTypesEnabled')"><span :class="confirmSlotTypeBtnText">Confirm Changes</span><span :class="confirmSlotTypeSpinner" ><b-spinner h6 ></b-spinner> Saving changes...</span></b-button>										
										</b-col>										
									</b-row>									
								</b-col>
							</b-row>				
						</b-tab>
						<b-tab title="Order&Collect Options" class="pt-2">
							<b-row>
								<b-col class="pt-4">
									<b-row class="mt-2"> 
										<b-col class="pl-4 pb-1">
											<h6 class="mr-2">Enable I Am Here</h6>
											<b-form-group class="pt-2">
													<b-form-radio-group
													id="imHere-radios"
													v-model="imHereSelected"
													:options="booleanOptions"
													name="imHere-radios"
													class="ml-4"
													></b-form-radio-group>
											</b-form-group>	
											<h6 class="mt-4 pt-4">Further Instructions Web Link:<span v-b-tooltip.hover title="Add a link to a web page providing further information on the collection process" ><b-icon-info-circle-fill></b-icon-info-circle-fill></span></h6>
											<b-form-input v-model='imHereInstructionsURL' type="text" class='' size='sm'></b-form-input>											
										</b-col>
										<b-col>
											<h6 class="mr-2">Customer Arrived Acknowledgement Text <span v-b-tooltip.hover title="Add a message of your choice that will be displayed on the web page after a customer has confirmed that they have arrived and are waiting to collect their order." ><b-icon-info-circle-fill></b-icon-info-circle-fill></span></h6>
											<b-form-textarea
											id="textarea"
											v-model="customCollectInstructions"
											placeholder="add your custom text here"
											rows="5"
											max-rows="5"
											class="pr-5"
											></b-form-textarea>	
										</b-col>
										<b-col class="ml-4 pl-4 pt-4">
											<b-button :variant="confirmOrderCollectVariant" class="w-75"  size='sm' @click="confirmSettingChanges('order&collect')"><span :class="confirmOrderCollectBtnText">Confirm changes</span><span :class="confirmOrderCollectSpinner" ><b-spinner h6 ></b-spinner> Saving changes...</span></b-button>										
										</b-col>
									</b-row>								
								</b-col>
							</b-row>						
						</b-tab>												
						<b-tab title="Packing Slip Options" class="pt-2">
							<b-row class="">
								<b-col class="pt-4">
									<b-row class="mt-2"> 
										<b-col class="pl-4 pb-1">
											<h6 class="mr-2">Show QR Code on Packaging slip: <span v-b-tooltip.hover title="You must add a web site URL  below for the QR Code to show on the packaging slip " class="pl-2"> <b-icon-info-circle-fill></b-icon-info-circle-fill></span></h6>
											<b-form-group class="pt-2">
													<b-form-radio-group
													id="promoSlip-radios"
													v-model="promoSlipSelected"
													:options="booleanOptions"
													name="promoSlip-radios"
													class="ml-4"
													></b-form-radio-group>
											</b-form-group>	
											<h6 class="mt-4 pt-4">QR Code Web Link:</h6>
											<b-form-input v-model='qrCodeURL' type="text" class='' size='sm'></b-form-input>											
										</b-col>
										<b-col>
											<h6 class="mr-2">Custom Packaging Slipt text: <span v-b-tooltip.hover title="Add a message of your choice or if using a QR code an explanation of where it links to." ><b-icon-info-circle-fill></b-icon-info-circle-fill></span></h6>
											<b-form-textarea
											id="textarea"
											v-model="customPSlipText"
											placeholder="add your custom text here"
											rows="5"
											max-rows="5"
											class="pr-5"
											></b-form-textarea>	
										</b-col>
										<b-col class="ml-4 pl-4 pt-4">
											<b-button :variant="confirmPSlipVariant" class="w-75"  size='sm' @click="confirmSettingChanges('PackagingSlip')"><span :class="confirmPSlipBtnText">Confirm changes</span><span :class="confirmPSlipSpinner" ><b-spinner h6 ></b-spinner> Saving changes...</span></b-button>										
										</b-col>
									</b-row>								
								</b-col>
							</b-row>							
						</b-tab>
						<b-tab title="SMS Options" class="pt-2">
							<b-row class="">
								<b-col class="pt-4">
									<b-row class="mt-2"> 
										<b-col class="pl-4 pb-1">
											<h6 class="mr-2">Allow SMS To Be Resent: <span v-b-tooltip.hover class="pl-2" title="Set to yes to enable the option to resend slot confirmation messages from the Manage Orders view. Additional SMS credits costs are incurred per resent SMS.  " ><b-icon-info-circle-fill></b-icon-info-circle-fill></span></h6>
											<b-form-group class="py-1 mb-4">
													<b-form-radio-group
													id="resendSMS-radios"
													v-model="resendSMSSelected"
													:options="resendSMSOptions"
													name="resendSMS-radios"
													class="ml-4"
													></b-form-radio-group>
											</b-form-group>	
											<div class="pt-4">
												<h6 class="mr-2">Web page to link to (URL Shortner such as Bitly recommended): <span v-b-tooltip.hover class="pl-2" title="You can use any URL that you require, but we recommend using a URL shortner (such as Bitly). This will reduce the amount of characters used in the SMS messages, which in turn will free up the amount of characters available for use in any custom text that you want to add." ><b-icon-info-circle-fill></b-icon-info-circle-fill></span></h6>
												<b-form-input v-model='wwwBitly' type="text" class='py-1' size='sm'></b-form-input>	
											</div>
										</b-col>
										<b-col>
											<h6 class="mr-2">Custom SMS Text: <span v-b-tooltip.hover class="pl-2" title="Optionally - Add a marketing message or additional collection / delivery instructions." ><b-icon-info-circle-fill></b-icon-info-circle-fill></span> </h6><h6 class="text-info float-right mr-3">Characters (including Bitly web link): {{ customSMSText.length + wwwBitly.length }}</h6>
											<b-form-textarea
											id="textarea"
											v-model="customSMSText"
											placeholder="add your custom SMS message text"
											rows="2"
											max-rows="2"
											class="pr-4 mb-1"
											></b-form-textarea>	
											<b-button :variant="confirmSMSVariant" class="w-75 mt-3"  size='sm' @click="confirmSettingChanges('SMS')"><span :class="confirmSMSBtnText">Confirm changes</span><span :class="confirmSMSSpinner" ><b-spinner h6 ></b-spinner> Saving changes...</span></b-button>										

										</b-col>
									</b-row>
									<b-row class="pt-3">
										<b-col>
											<p class="text-danger pl-4 pt-2">Please note that resending SMS and/or adding web links and custom text will have cost implications per message sent. 
											For example adding a web link with custom text of up to 150 characters (including the Bitly web link) will mean that every SMS confirmation sent will cost 2 credits in total.</p>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
						</b-tab>
						<b-tab title="Manage Core Hours" class="manageCoreHours pt-2">
							<b-row>
								<b-col cols="7">
									<span>Viewing {{ viewTypeSelected | getSlotTypeText }}</span>
									<corehours-slots-grid-configure :slots="weekOneData"  :weekData="coreWeekData" :admin="true" week="weekOne" class="pt-2"/>
								</b-col>
								<b-col cols="5" class="pl-4 pt-3">
									<b-row v-if="multiFulfilmentCount >= 2">
										<b-col>
										<b-form-group label="Select an option to configure" class="mt-3 pt-2 manageCoreHoursRadios">
											<b-form-radio-group id="option-radio-group1" 
												:options="orderTypes" 
												v-model="viewTypeSelected" 
												name="radio-sub-component1" 
												:stacked="false">
											</b-form-radio-group>
										</b-form-group>
										</b-col>
									</b-row>
									<b-row class="mt-2">
										<b-col>
											<span>Set core {{ viewTypeSelected | getSlotTypeText }} hours for a week</span>
											<b-form-group label-cols="4" label-cols-lg="4" label-size="sm" label="Core start hour:" label-for="input-sm" class="mt-3">
												<b-form-select v-model="startSelected" :options="startSlotOptions" size="sm" class="w-50"></b-form-select>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<b-form-group label-cols="3" label-cols-lg="4" label-size="sm" label="Core End hour:" label-for="input-sm">
												<b-form-select v-model="endSelected" :options="endSlotOptions" size="sm" class="w-50"></b-form-select>
											</b-form-group>
										</b-col>
									</b-row>
									<b-row  v-if="multiFulfilmentCount >= 2" class="">
										<b-col>
											<b-form-group label="Select which fulfiment (slot types) to apply the changes to:" class="mt-3 pt-2 manageCoreHoursRadios">
												<b-form-checkbox
													v-model="allSelected"
													:indeterminate="indeterminate"
													@change="toggleAll"
												>          
													{{ allSelected ? 'Un-select All' : 'Select All' }}
												</b-form-checkbox>
												<b-form-checkbox-group
													id="orderTypes"
													v-model="orderTypesSelected"
													:options="orderTypes"
													name="orderTypes"
													class="ml-1"
												></b-form-checkbox-group>
											</b-form-group>
										</b-col>
									</b-row>	
									<b-row class="mt-4">
										<b-col>
											<b-button :variant="confirmBtnVariant" class="" :disabled="confirmBtnState" @click="confirmChanges()"><span :class="confirmBtnText">Confirm changes</span><span :class="confirmSpinner" ><b-spinner h6 ></b-spinner> Saving changes...</span></b-button>
										</b-col>
									</b-row>									
								</b-col>
							</b-row>						
						</b-tab>
					</b-tabs>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
				</b-col>
				<b-col>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import NavHeader from './NavHeader'
import {RepositoryFactory} from '../api/RepositoryFactory'
import {mixin} from '../mixins/clickAndCollectMixins'
//import EventBus from './../eventBus';
const SettingsRepoPost = RepositoryFactory.post('settings')
const SlotsRepoPost = RepositoryFactory.post('slots')
import CorehoursSlotsGridConfigure from './CorehoursSlotsGridConfigure'
export default{
name: 'settingsClickCollect',
components: {CorehoursSlotsGridConfigure, NavHeader},
mixins: [mixin],
	data(){
		return{
			qrCodeText: null,
			offsetCCSlotsDisabled: true,
			offsetLSlotsDisabled: true,
			offsetDSlotsDisabled: true,
			offsetCCSlots: 2,
			offsetLSlots: 2,
			offsetDSlots:2,
			numberCCSlotsDisabled: true,
			numberLSlotsDisabled: true,
			numberDSlotsDisabled: true,
			numberCCSlots: 1,
			numberLSlots: 1,
			numberDSlots:1,
			orderTypesEnabledSelected: [],
			confirmSMSVariant: 'primary',
			confirmSMSSpinner: 'd-none',
			confirmSMSBtnText: "",
			confirmSlotTypeVariant: 'primary',
			confirmSlotTypeSpinner: 'd-none',
			confirmSlotTypeBtnText: "",
			confirmPSlipVariant: 'primary',
			confirmPSlipSpinner: 'd-none',
			confirmPSlipBtnText: "",
			customCollectInstructions: "Please wait in your vehicle",
			imHereSelected: 1,
			imHereInstructionsURL: 'www.alink.com',
			confirmOrderCollectVariant: 'primary',
			confirmOrderCollectSpinner: 'd-none',
			confirmOrderCollectBtnText: "",
			confirmBtnVariant: 'primary',
			confirmSpinner: 'd-none',
			confirmBtnText: "",
			customSMSText: "",
			qrCodeURL: "",
			wwwBitly: "",
			resendSMSSelected: 0,
			resendSMSOptions: [
				{ text: 'Yes', value: 1 },
				{ text: 'No', value: 0 }
			],
			promoSlipSelected: 0,
			orderTypesEnabledOptions: [
			{value: "clickandcollect", text : "Order&Collect Desk" },
			{value: "locker", text : "Locker" },
			{value: "delivery", text : "Delivery"}],
			headerText: "Order&Collect - General Settings",
			multiFulfilmentOptions: false,
			multiFulfilmentCount: 0,
			weekOneDateRange : "",
			weekOneData: [],
			coreWeekData:  [],
			indeterminate: false,
			confirmBtnState: true,
			allSelected: false,
			viewTypeSelected: '',
			viewTypes:  [],
			orderTypesSelected: [],
			constOrderTypes: [],			
			orderTypes:  [],
			copySelected: 'Do not copy',
			startSelected: null,
			endSelected: null,
		}
	},
	methods: {
		async confirmSettingChanges(settingType){
			var payload = new FormData();
			var settings = [];

			if(settingType == 'orderTypesEnabled')
			{
				this.orderTypes = [] // empty the array that controls which Fulfilment / slot type radio options are available on the Manage Core Hours Tab
				var names = this.orderTypesEnabledSelected.map((name)=>{
						this.orderTypes.push(name) // add to the array that controls which Fulfilment / slot type radio options are available on the Manage Core Hours Tab
						return name + 'Enabled'				
					})	
			}

			switch(settingType)
			{				
				case 'orderTypesEnabled':
					settings.push({ key: 'availableSlots', value : this.numberCCSlots })
					settings.push({ key: 'availableLockers', value : this.numberLSlots})
					settings.push({ key: 'deliverySlots' , value : this.numberDSlots})				
					settings.push({ key: 'sameDayOffset' , value : this.offsetCCSlots})				
					payload.append('names', JSON.stringify(names));				
					break;
				case 'order&collect':
					settings.push({ key: 'imHere', value : this.imHereSelected })
					settings.push({ key: 'customCollectInstructions', value : this.customCollectInstructions})
					settings.push({ key: 'imHereInstructionsURL' , value : this.imHereInstructionsURL.replace(/(^\w+:|^)\/\//, '')})
					break;
				case 'PackagingSlip':
					settings.push({ key: 'packagingSlipPromo', value : this.promoSlipSelected })
					settings.push({ key: 'packagingSlipText', value : this.customPSlipText})
					settings.push({ key: 'qrCodeURL' , value : this.qrCodeURL.replace(/(^\w+:|^)\/\//, '')})
					break;
				case 'SMS':
					settings.push({ key: 'resendSMS', value : this.resendSMSSelected })
					settings.push({ key: 'customSMSText', value : this.customSMSText})
					settings.push({ key: 'wwwBitly' , value : this.wwwBitly})
					break;
			}
			
			// Save our settings
			payload.append('settings', JSON.stringify(settings))
			payload.append('storeId', this.$store.state.storeId)
			payload.append('settingType', settingType)
			await SettingsRepoPost.postUpdateStoreSettings(payload)
			
			//Update the store with the new values
			settings.push({ key: 'settingType' , value : settingType})			
			settings.push({ key: 'fulfilmentOptions' , value : names})			
			this.$store.commit("updateStoreSettings", settings);
			
			// Show saving spinners
			switch(settingType)
			{
				case 'orderTypesEnabled':
					this.confirmSlotTypeVariant = 'outline-success';
					this.confirmSlotTypeBtnText = 'd-none';
					this.confirmSlotTypeSpinner = ''	;	
					setTimeout(() => {
						this.confirmSlotTypeBtnText = '';
						this.confirmSlotTypeSpinner = 'd-none';
						this.confirmSlotTypeVariant = 'primary';
					}, 3000);
				break;				
				case 'order&collect':
					this.confirmOrderCollectVariant = 'outline-success';
					this.confirmOrderCollectBtnText = 'd-none';
					this.confirmOrderCollectSpinner = ''	;	
					setTimeout(() => {
						this.confirmOrderCollectBtnText = '';
						this.confirmOrderCollectSpinner = 'd-none';
						this.confirmOrderCollectVariant = 'primary';
					}, 3000);
				break;
				case 'PackagingSlip':
					this.confirmPSlipVariant = 'outline-success';
					this.confirmPSlipBtnText = 'd-none';
					this.confirmPSlipSpinner = ''	;	
					setTimeout(() => {
						this.confirmPSlipBtnText = '';
						this.confirmPSlipSpinner = 'd-none';
						this.confirmPSlipVariant = 'primary';
					}, 3000);
				break;
				case 'SMS':
					this.confirmSMSVariant = 'outline-success';
					this.confirmSMSBtnText = 'd-none';
					this.confirmSMSSpinner = ''	;	
					setTimeout(() => {
						this.confirmSMSBtnText = '';
						this.confirmSMSSpinner = 'd-none';
						this.confirmSMSVariant = 'primary';
					}, 3000);
				break;
			}				
		},
		disableOption(index, type){
			let disabledState;
			if(type == 'start')
			{
				disabledState = (index > this.endSelected)? true : false
			}
			else
			{
				disabledState = (index < this.startSelected)? true : false
			}		 
			return disabledState
		},
		toggleAll(checked) {
			this.orderTypesSelected = checked ? this.constOrderTypes.slice() : []
			},
		async confirmChanges(){		
			var payload = new FormData();
			// if only one fulfilment option is selected create an array with the viewTypeSelected or else use the orderTypesSelected Array
			let orderTypesSelected = (this.orderTypesSelected.length >=1 )? this.orderTypesSelected : [this.viewTypeSelected];
			var payloadData = this.coreWeekData;
			payload.append('payload', JSON.stringify(payloadData.slice(0,7)));
			payload.append('updateType', JSON.stringify(orderTypesSelected))
			payload.append('corePeriod', 'week')
			payload.append('startSelected', this.startSelected)
			payload.append('endSelected', this.endSelected)			
			payload.append('storeId', this.$store.state.storeId)			
			
			await SlotsRepoPost.postUpdateCoreHours(payload)
			
			//Update the store with the new values
			let settings = []
		
			settings.push({ key: 'settingType' , value : "coreHours"})	
			settings.push({ key: 'coreStartHour' , value : this.startSelected })			
			settings.push({ key: 'coreEndHour' , value : this.endSelected})
			settings.push({ key: 'fulfilmentTypes' , value : orderTypesSelected })
			
			this.$store.commit("updateStoreSettings", settings);
			
				this.confirmBtnVariant = 'outline-success'
				this.confirmBtnText= 'd-none'
				this.confirmSpinner = ''		
				setTimeout(() => {
				this.confirmBtnText = ''
				this.confirmSpinner = 'd-none'
				this.confirmBtnVariant = 'primary'
			}, 3000)			
		},
		getFulfilmentCount(){
			let count = 0;
			if (this.$store.state.settings.clickandcollectEnabled == true)
			{
				count++
				this.orderTypes.push({ value : 'clickandcollect', text : 'Click&Collect Desk'})
				this.numberCCSlotsDisabled = false
				this.offsetCCSlotsDisabled = false
				this.numberCCSlots = this.$store.state.settings.availableSlots 
				this.offsetCCSlots = this.$store.state.settings.sameDayOffset * -1 // this is required as the value has to be set as negative in the db
				this.constOrderTypes.push('clickandcollect')
				this.viewTypes.push('clickandcollect')
				this.viewTypeSelected = 'clickandcollect'
				this.orderTypesEnabledSelected.push('clickandcollect')
			}
			
			if (this.$store.state.settings.lockerEnabled == true)
			{
				count++
				this.orderTypes.push({ value : 'locker', text : 'Locker'})
				this.numberLSlots = this.$store.state.settings.availableLockers
				this.offsetLSlots = this.$store.state.settings.sameDayOffset * -1 // this is required as the value has to be set as negative in the db
				this.numberLSlotsDisabled = false
				this.offsetLSlotsDisabled = false
				this.orderTypesEnabledSelected.push('locker')
				this.constOrderTypes.push('locker')
				this.viewTypes.push('locker')
				if(this.viewTypeSelected.length == 0)
				{
				this.viewTypeSelected= 'locker'
				}
			}
			
			if (this.$store.state.settings.deliveryEnabled == true)
			{
				count++
				this.orderTypes.push({ value : 'delivery', text : 'Delivery'})
				this.numberDSlots = this.$store.state.settings.deliverySlots
				this.offsetDSlots = this.$store.state.settings.sameDayOffset  * -1 // this is required as the value has to be set as negative in the db
				this.numberDSlotsDisabled = false
				this.offsetDSlotsDisabled = false
				this.orderTypesEnabledSelected.push('delivery')
				this.constOrderTypes.push('delivery')
				this.viewTypes.push('delivery')
				if(this.viewTypeSelected.length == 0)
				{
				this.viewTypeSelected= 'delivery'
				}
			}
				this.multiFulfilmentCount = count
				this.promoSlipSelected = this.$store.state.settings.packagingSlipPromo
				this.customPSlipText = this.$store.state.settings.packagingSlipText
				this.qrCodeURL = this.$store.state.settings.qrCodeURL
				this.resendSMSSelected = this.$store.state.settings.resendSMS
				this.customSMSText = this.$store.state.settings.customSMSText
				this.wwwBitly = this.$store.state.settings.wwwBitly		
				this.imHereSelected	= 	this.$store.state.settings.imHere
				this.imHereInstructionsURL = this.$store.state.settings.imHereInstructionsURL
				this.customCollectInstructions = this.$store.state.settings.customCollectInstructions
		}
	},
	computed:{
		endSlotOptions(){
			let options =  [
			{ value : 1, text: '1:00 am', disabled : this.disableOption(1, 'end')},
			{ value : 2, text: '2:00 am', disabled : this.disableOption(2, 'end')},
			{ value : 3, text: '3:00 am', disabled : this.disableOption(3, 'end')},
			{ value : 4, text: '4:00 am', disabled : this.disableOption(4, 'end')},
			{ value : 5, text: '5:00 am', disabled : this.disableOption(5, 'end')},
			{ value : 6, text: '6:00 am', disabled : this.disableOption(6, 'end')},
			{ value : 7, text: '7:00 am', disabled : this.disableOption(7, 'end')},
			{ value : 8, text: '8:00 am', disabled : this.disableOption(8, 'end')},
			{ value : 9, text: '9:00 am', disabled : this.disableOption(9, 'end')},
			{ value : 10, text: '10:00 am', disabled : this.disableOption(10, 'end')},
			{ value : 11, text: '11:00 am', disabled : this.disableOption(11, 'end')},
			{ value : 12, text: '12:00 pm', disabled : this.disableOption(12, 'end')},
			{ value : 13, text: '1:00 pm', disabled : this.disableOption(13, 'end')},
			{ value : 14, text: '2:00 pm', disabled : this.disableOption(14, 'end')},
			{ value : 15, text: '3:00 pm', disabled : this.disableOption(15, 'end')},
			{ value : 16, text: '4:00 pm', disabled : this.disableOption(16, 'end')},
			{ value : 17, text: '5:00 pm', disabled : this.disableOption(17, 'end')},
			{ value : 18, text: '6:00 pm', disabled : this.disableOption(18, 'end')},
			{ value : 19, text: '7:00 pm', disabled : this.disableOption(19, 'end')},
			{ value : 20, text: '8:00 pm', disabled : this.disableOption(20, 'end')},
			{ value : 21, text: '9:00 pm', disabled : this.disableOption(21, 'end')},
			{ value : 22, text: '10:00 pm', disabled : this.disableOption(22, 'end')},
			{ value : 23, text: '11:00 pm', disabled : this.disableOption(23, 'end')},
			{ value : 24, text: '12:00 am', disabled : this.disableOption(24, 'end')}
			]
			return options
		},
		startSlotOptions(){
		let options =  [
		{ value : 1, text: '1:00 am', disabled : this.disableOption(1, 'start')},
		{ value : 2, text: '2:00 am', disabled : this.disableOption(2, 'start')},
		{ value : 3, text: '3:00 am', disabled : this.disableOption(3, 'start')},
		{ value : 4, text: '4:00 am', disabled : this.disableOption(4, 'start')},
		{ value : 5, text: '5:00 am', disabled : this.disableOption(5, 'start')},
		{ value : 6, text: '6:00 am', disabled : this.disableOption(6, 'start')},
		{ value : 7, text: '7:00 am', disabled : this.disableOption(7, 'start')},
		{ value : 8, text: '8:00 am', disabled : this.disableOption(8, 'start')},
		{ value : 9, text: '9:00 am', disabled : this.disableOption(9, 'start')},
		{ value : 10, text: '10:00 am', disabled : this.disableOption(10, 'start')},
		{ value : 11, text: '11:00 am', disabled : this.disableOption(11, 'start')},
		{ value : 12, text: '12:00 pm', disabled : this.disableOption(12, 'start')},
		{ value : 13, text: '1:00 pm', disabled : this.disableOption(13, 'start')},
		{ value : 14, text: '2:00 pm', disabled : this.disableOption(14, 'start')},
		{ value : 15, text: '3:00 pm', disabled : this.disableOption(15, 'start')},
		{ value : 16, text: '4:00 pm', disabled : this.disableOption(16, 'start')},
		{ value : 17, text: '5:00 pm', disabled : this.disableOption(17, 'start')},
		{ value : 18, text: '6:00 pm', disabled : this.disableOption(18, 'start')},
		{ value : 19, text: '7:00 pm', disabled : this.disableOption(19, 'start')},
		{ value : 20, text: '8:00 pm', disabled : this.disableOption(20, 'start')},
		{ value : 21, text: '9:00 pm', disabled : this.disableOption(21, 'start')},
		{ value : 22, text: '10:00 pm', disabled : this.disableOption(22, 'start')},
		{ value : 23, text: '11:00 pm', disabled : this.disableOption(23, 'start')},
		{ value : 24, text: '12:00 am', disabled : this.disableOption(24, 'start')}
		]
		return options
	},
	startSelectedDesk(){
		return this.$store.state.settings.startSelectedDesk
	},
	endSelectedDesk(){
		return this.$store.state.settings.endSelectedDesk
	},
	startSelectedLocker(){
		return this.$store.state.settings.startSelectedLocker
	},
	endSelectedLocker(){
		return this.$store.state.settings.endSelectedLocker
	},
	startSelectedDelivery(){
		return this.$store.state.settings.startSelectedDelivery
	},
	endSelectedDelivery(){
		return this.$store.state.settings.endSelectedDelivery
	}
	},
	watch: {
		orderTypesEnabledSelected(newVal) {
			let clickandcollectSelected = newVal.filter((item)=> item == 'clickandcollect')
			this.numberCCSlotsDisabled = (clickandcollectSelected.length >= 1)? false : true;
			let lockerSelected = newVal.filter((item)=> item == 'locker')
			this.numberLSlotsDisabled = (lockerSelected.length >= 1)? false : true;
			let deliverySelected = newVal.filter((item)=> item == 'delivery')
			this.numberDSlotsDisabled = (deliverySelected.length >= 1)? false : true;

			// ensure that at least 1 slots is available or zero if a fulfilment type is not selected
			this.numberCCSlots = (newVal.includes('clickandcollect') )? (this.numberCCSlots == 0)? 1: this.numberCCSlots : 0			
			this.numberLSlots = (newVal.includes('locker') )? (this.numberLSlots == 0)? 1: this.numberLSlots : 0
			this.numberDSlots = (newVal.includes('delivery') )? (this.numberDSlots == 0)? 1: this.numberDSlots : 0			
		},
		orderTypesSelected(newVal) {
			// Handle changes in individual checkboxes
			if (newVal.length === 0) {
			this.indeterminate = false
			this.allSelected = false
			this.confirmBtnState = true
			} else if (newVal.length === this.orderTypes.length) {
			this.indeterminate = false
			this.allSelected = true
			this.confirmBtnState = false
			} else {
			this.indeterminate = true
			this.allSelected = false
			this.confirmBtnState = false
			}
		},
		viewTypeSelected(){
			this.fetchCoreSlots(this.$store.state.bid)
			console.log(this.viewTypeSelected)
			console.log(this.startSelectedDesk)
			console.log(this.endSelectedDesk)
			console.log(this.startSelectedLocker)
			console.log(this.endSelectedLocker)
			console.log(this.$store.state.settings.startSelectedLocker)
			console.log(this.$store.state.settings.endSelectedLocker)
			switch(this.viewTypeSelected)
			{	
				case 'clickandcollect':
				this.startSelected = this.startSelectedDesk;
				this.endSelected = this.endSelectedDesk;
				break;
				case 'locker':
				this.startSelected = this.startSelectedLocker;
				this.endSelected = this.endSelectedLocker;
				break;
				case 'delivery':
				this.startSelected = this.startSelectedDelivery;
				this.endSelected = this.endSelectedDelivery;
				break;
			}
		},
		startSelected(){
			this.fetchCoreSlots(this.$store.state.bid);

			if(this.orderTypesEnabledSelected.length == 1 )
			{
				this.confirmBtnState = false
			}
		},
		endSelected(){
			this.fetchCoreSlots(this.$store.state.bid);
			if(this.orderTypesEnabledSelected.length == 1 )
			{
				this.confirmBtnState = false
			}
		}
	},
	created(){
		this.fetchCoreSlots(this.$store.state.bid)
		this.getFulfilmentCount()
	}
}
</script>
<style scoped>

.manageCoreHours .manageCoreHoursRadios{
text-align: left;
}

</style>